import React, { useState, useEffect } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify"
import Swal from "sweetalert2"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getsearchUsers, sendUserNotification } from "services/ApiService"

function UserNotification() {
  const [saveLoader, setSaveLoader] = useState(false)
  const [sendOption, setSendOption] = useState("one")
  const [email, setEmail] = useState("")
  const [userId, setUserId] = useState("")
  const [title, setTitle] = useState("")
  const [message, setMessage] = useState("")
  const [searchText, setSearchText] = useState("")
  const [searchResults, setSearchResults] = useState([])
  const [showResults, setShowResults] = useState(false)

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchText.length > 1) {
        // Replace with your actual API URL
        getsearchUsers(searchText)
          .then(res => {
            setSearchResults(res.data || [])
            setShowResults(true)
          })
          .catch(err => {
            console.error(err)
            setSearchResults([])
          })
      } else {
        setSearchResults([])
        setShowResults(false)
      }
    }, 100) // Debounce input

    return () => clearTimeout(delayDebounceFn)
  }, [searchText])

  // console.log("searchResults", searchResults)
  // console.log("email.....", searchText)
  // console.log("userId.....", userId)

  const handleSubmit = e => {
    e.preventDefault()
    setSaveLoader(true)
    const reqObj = {
      userId: userId,
      title: title,
      message: message,
    }

    Swal.fire({
      title: `Are you sure you want to sent a notification to  ${
        reqObj.userId == "all" ? "all users " : "this user"
      } ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Yes Send it!`,
    }).then(result => {
      if (result.isConfirmed) {
        sendUserNotification(reqObj)
          .then(res => {
            setSaveLoader(false)
            setUserId("")
            setTitle("")
            setEmail("")
            setMessage("")
            setSearchText("")
            setSendOption("one")
            setSearchResults([])
            // toast.success(res.msg)
            Swal.fire("Success!", res.msg, "success")
          })
          .catch(err => {
            if (err?.errors) {
              setSaveLoader(false)
              err.errors.forEach(error => {
                // toast.error(error.msg)
                Swal.fire("Error!", error.msg, "error")
              })
            } else {
              setSaveLoader(false)
              toast.error(err?.message || "An error occurred")
            }
          })
          .catch(() => Swal.fire("Error!", "Failed to update status.", "error"))
      }
    })
  }

  const handleSelect = (email, id) => {
    setSearchText(email)
    setEmail(email)
    setUserId(id)
    setShowResults(false)
  }
  const handleSendOption = option => {
    setSendOption(option)
    if (option === "all") {
      setEmail("")
      setUserId("all")
    }
  }
  return (
    <React.Fragment>
      <ToastContainer />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dashboard" breadcrumbItem="User Notification" />
          <Row className="justify-content-center" style={{ minHeight: "75vh" }}>
            <Col md={8} lg={6}>
              <Card
                className="p-3"
                style={{
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                  borderRadius: "12px",
                  backgroundColor: "#ffffff",
                }}
              >
                <CardBody>
                  {sendOption === "one" ? (
                    <Row className="mb-4 align-items-center position-relative">
                      <Label className="col-sm-12 col-md-3 col-form-label p-0">
                        Search Email
                      </Label>
                      <Col sm={12} md={9}>
                        <Input
                          type="search"
                          disabled={sendOption !== "one"}
                          className="form-control"
                          placeholder="Search here..."
                          value={searchText}
                          onChange={e => setSearchText(e.target.value)}
                          onFocus={() => {
                            if (searchResults.length) setShowResults(true)
                          }}
                        />
                        {showResults && searchResults.length > 0 && (
                          <div
                            className="position-absolute bg-white border rounded shadow-sm mt-1 w-100"
                            style={{
                              zIndex: 1000,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {searchResults.map((result, index) => (
                              <div
                                key={index}
                                className="px-3 py-2 border-bottom hover-bg-light"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleSelect(
                                    result.firstname +
                                      " " +
                                      result.lastname +
                                      "/" +
                                      result.email,
                                    result.id
                                  )
                                }
                              >
                                {result.firstname} {result.lastname} /{" "}
                                {result.email}
                              </div>
                            ))}
                          </div>
                        )}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Form onSubmit={handleSubmit}>
                    {/* Search Email */}

                    {/* Send Options */}
                    <Row className="mb-4">
                      <Col sm={12}>
                        <div className="d-flex flex-column gap-3">
                          {/* One User */}
                          <div className="d-flex align-items-center gap-3 flex-wrap">
                            <Input
                              type="radio"
                              name="sendOption"
                              value="one"
                              checked={sendOption === "one"}
                              onChange={() => handleSendOption("one")}
                              className="form-check-input"
                              id="sendToOne"
                            />
                            <Label
                              htmlFor="sendToOne"
                              className="form-check-label mb-0"
                            >
                              Send To One User
                            </Label>
                            {/* <Input
                              type="text"
                              className="form-control"
                              style={{ maxWidth: "250px" }}
                              disabled={sendOption !== "one"}
                              value={email}
                            /> */}
                          </div>

                          {/* All Users */}
                          <div className="d-flex align-items-center gap-3">
                            <Input
                              type="radio"
                              name="sendOption"
                              value="all"
                              checked={sendOption === "all"}
                              onChange={() => handleSendOption("all")}
                              className="form-check-input"
                              id="sendToAll"
                            />
                            <Label
                              htmlFor="sendToAll"
                              className="form-check-label mb-0"
                            >
                              Send To All Users
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    {/* Headline Text */}
                    <Row className="mb-3">
                      <Col>
                        <div className="d-flex justify-content-between">
                          <Label className="form-label">Headline Text</Label>
                          <span className="text-muted">
                            Limit: 75 Characters
                          </span>
                        </div>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Title"
                          maxLength="75"
                          value={title}
                          onChange={e => setTitle(e.target.value)}
                          required
                        />
                      </Col>
                    </Row>

                    {/* Message Text */}
                    <Row className="mb-4">
                      <Col>
                        <div className="d-flex justify-content-between">
                          <Label className="form-label">Message Text</Label>
                          <span className="text-muted">
                            Limit: 350 Characters
                          </span>
                        </div>
                        <Input
                          type="textarea"
                          className="form-control"
                          placeholder="Enter your message"
                          maxLength="350"
                          rows={4}
                          value={message}
                          onChange={e => setMessage(e.target.value)}
                          required
                        />
                      </Col>
                    </Row>

                    {/* Submit Button */}
                    <Row className="justify-content-center">
                      <Col sm={9} className="d-flex justify-content-center">
                        <Button
                          type="submit"
                          color="primary"
                          className="w-md"
                          disabled={saveLoader}
                        >
                          {saveLoader ? (
                            <div
                              className="spinner-border spinner-border-sm text-light mx-5"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UserNotification
